import React from 'react';
import './SearchBar.css';
import SearchSvgIcon from './../../../assets/svg/akar-icons_search.svg';

type DynamicSearchBarProps = {
  onChange: (value: string) => void;
  placeHolder: string;
  searchName?: string;
  disabled?: boolean;
  className?: string;
  iconNeeded?: boolean;
  required?:boolean;
  type?:string;
  maxLength?: number;
  minLength?: number;
  value?: string;
};

const DynamicSearchBar = ({
  onChange,
  placeHolder,
  searchName,
  disabled,
  className,
  iconNeeded,
  required,
  type = 'text',
  maxLength,
  minLength,
  value
}: DynamicSearchBarProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      let inputValue = e.target.value;
      if (type === 'number') {
        // Remove all non-digit characters
        inputValue = inputValue.replace(/\D/g, '');
        // Enforce maxLength if provided
        if (maxLength && inputValue.length > maxLength) {
          inputValue = inputValue.slice(0, maxLength);
        }
        onChange(inputValue);
      } else {
        onChange(inputValue);
      }
  };
  return (
    <div className={`search-bar-container ${className}`}>
      {searchName && (
        <label  className={`search-name-fromparent ${required && 'yes'} ${disabled}`}>{searchName}</label>
      )}
      <div className="search_bar_form-field">
        {/* <img className="search_bar_icon" src={SearchSvgIcon}></img> */}
        {iconNeeded ? <SearchSvgIcon className="search_bar_icon" /> : null}
        <input
          className="search_bar_input_field"
          placeholder={placeHolder}
          onChange={handleChange}
          disabled={disabled}
          type={type === 'number' ? 'text' : type}
          inputMode={type === 'number' ? 'numeric' : undefined}
          pattern={type === 'number' ? '\\d*' : undefined}
          maxLength={maxLength}
          minLength={minLength}
          value={value}
        />
      </div>
    </div>
  );
};

export default DynamicSearchBar;
